import { makeApi } from "@zodios/core";

import { currentUserResponseSchema } from "@/data/api/kili/current-user/current-user.type";

export const currentUserApi = makeApi([
  {
    method: "get",
    path: "/",
    response: currentUserResponseSchema,
    alias: "getCurrentUser",
  },
]);
